import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Removes a role bundled by a department.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the department.
 * @param roleUid - Unique identifier of the role to remove.
 * @returns OperationResult (no payload).
 */
export const deleteDepartmentRole = async (instance: KyInstance, uid: string, roleUid: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.departments.roleByUid, uid, roleUid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
